import React, { useState } from "react";
import { format } from "date-fns";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { requestAuth } from "../../../components/services/RequestService";
import { Button } from "../../../components/Buttons";
import { toast } from "react-toastify";

export const DATE_FIELDS = [
  { id: 1949, name: "etd", label: "Fecha Tentativa Salida de Puerto (ETD)" },
  { id: 1950, name: "eta", label: "Fecha Tentativa Arribo a Puerto (ETA)" },
  { id: 1998, name: "fechaRequerimientoDam", label: "Fecha Requerimiento DAM" },
  {
    id: 1999,
    name: "fechaEstimadaDePagoDim",
    label: "Fecha Estimada de Pago DIM",
  },
  {
    id: 2000,
    name: "fechaConfirmadaPagoDim",
    label: "Fecha Confirmada Pago DIM",
  },
  { id: 2001, name: "fechaDeDim", label: "Fecha de DIM" },
  {
    id: 2002,
    name: "fechaVencimientoDim(Ritex)",
    label: "Fecha Vencimiento DIM (RITEX)",
  },
  { id: 2003, name: "fechaNacionalización", label: "Fecha Nacionalización" },
  {
    id: 2004,
    name: "fechaPagoTributosAduaneros",
    label: "Fecha Pago Tributos Aduaneros",
  },
  {
    id: 2005,
    name: "fechaAsignaciónDeCanal",
    label: "Fecha Asignación de Canal",
  },
  { id: 2006, name: "fechaPaseDeSalida", label: "Fecha Pase de Salida" },
  {
    id: 2007,
    name: "fechaOrdenDeRecepción",
    label: "Fecha Orden de Recepción",
  },
  {
    id: 2008,
    name: "fechaLimiteDevoluciónContenedores",
    label: "Fecha Limite Devolución Contenedores",
  },
];

export const CalendarFormModal = ({ date, event, onClose, reload }) => {
  const [selectedField, setSelectedField] = useState(
    event
      ? {
          label:
            DATE_FIELDS.find((f) => f.name === event.FieldNameDate)?.label ||
            event.FieldNameDate,
          value: DATE_FIELDS.find((f) => f.name === event.FieldNameDate)?.id,
        }
      : null,
  );
  const [selectedProcedure, setSelectedProcedure] = useState(
    event
      ? {
          label: event.codigoDeInterno || event.ProcedureId,
          value: event.ProcedureId,
        }
      : null,
  );
  const [loading, setLoading] = useState(false);

  // En caso de que se abra desde el botón general sin fecha seleccionada
  const [selectedDate, setSelectedDate] = useState(
    event ? event.Value : date ? format(date, "yyyy-MM-dd") : "",
  );

  const loadProcedures = async (inputValue) => {
    try {
      const query = inputValue
        ? `&ForQuery=internCode&TypeQuery=${inputValue}`
        : "";
      const url = `/procedure/openprocedures?PageNumber=1${query}`;

      const response = await requestAuth("get", url);
      const items =
        response.data?.data?.items ||
        response.data?.items ||
        response.data ||
        [];

      return items.map((proc) => ({
        label: `${proc.internCode || proc.id}`,
        value: proc.id,
      }));
    } catch (error) {
      console.error("Error loading procedures", error);
      return [];
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!selectedField || !selectedProcedure || !selectedDate) {
      toast.warning("Por favor complete todos los campos requeridos");
      return;
    }

    setLoading(true);
    const payload = [
      {
        FieldId: selectedField.value,
        ProcedureId: selectedProcedure.value,
        Value: selectedDate,
      },
    ];

    try {
      await requestAuth("post", "/dataset", payload);
      toast.success(
        event ? "Fecha actualizada con éxito" : "Fecha registrada con éxito",
      );
      if (reload) reload();
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("Hubo un error al procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("¿Está seguro de que desea eliminar esta fecha?"))
      return;

    setLoading(true);
    const payload = [
      {
        FieldId: selectedField.value,
        ProcedureId: selectedProcedure.value,
        Value: "", // Eliminar enviando vacío
      },
    ];

    try {
      await requestAuth("post", "/dataset", payload);
      toast.success("Fecha eliminada con éxito");
      if (reload) reload();
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("Hubo un error al eliminar la fecha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full p-6 bg-white rounded-lg">
      <h2 className="text-xl font-bold mb-4 text-gray-800">
        {event ? "Detalle de Fecha" : "Registrar Fecha de Trámite"}
      </h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="flex flex-col">
          <label className="mb-1 text-sm font-semibold text-gray-600">
            Fecha
          </label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="p-2 border border-gray-300 rounded focus:ring focus:ring-blue-200 outline-none"
            required
          />
        </div>

        <div className="flex flex-col relative z-[60]">
          <label className="mb-1 text-sm font-semibold text-gray-600">
            Campo de Fecha
          </label>
          <Select
            options={DATE_FIELDS.map((f) => ({ label: f.label, value: f.id }))}
            value={selectedField}
            onChange={setSelectedField}
            placeholder="Seleccione el campo..."
            isClearable
            isDisabled={!!event}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>

        <div className="flex flex-col relative z-50">
          <label className="mb-1 text-sm font-semibold text-gray-600">
            Trámite
          </label>
          <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={loadProcedures}
            value={selectedProcedure}
            onChange={setSelectedProcedure}
            placeholder="Buscar trámite por Código Interno..."
            isClearable
            isDisabled={!!event}
            noOptionsMessage={() => "No se encontraron trámites"}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>

        <div className="flex justify-between gap-2 mt-4">
          <div className="flex gap-2">
            {event && (
              <Button
                type="button"
                className="bg-red-500 text-white hover:bg-red-600 py-2 px-4 shadow-md"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Eliminando..." : "Eliminar"}
              </Button>
            )}
          </div>
          <div className="flex gap-2">
            <Button
              type="button"
              className="bg-gray-300 text-gray-800 hover:bg-gray-400 py-2 px-4 text-sm"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              className="py-2 px-4 shadow-md bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white"
              disabled={loading}
            >
              {loading ? "Guardando..." : event ? "Actualizar" : "Guardar"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};
